<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { SmartmodelMessage } from './types/smartmodel-message';

    export let favorites: string[] = [];

    const dispatch = createEventDispatcher<{ select: SmartmodelMessage }>();

    const select = (item: string) => {
        dispatch('select', { receiver: 'select', data: item });
    };
</script>

<div class="row">
    {#each favorites as favorite}
        <div class="col-auto">
            <button class="btn btn-primary" on:click="{() => select(favorite)}">
                {favorite}
            </button>
        </div>
    {/each}
</div>
